import { readFile } from 'lib/api/public';
import { Avatar, Box, SxProps, Theme } from '@mui/material';
import { CSSProperties } from 'react';

type LogoObject = {
  name?: string;
  logo?: string;
  logoUrl?: string;
};

const LogoOrFromName = ({
  object,
  style,
  logoStyle,
}: {
  object: LogoObject;
  style?: SxProps<Theme>;
  logoStyle?: CSSProperties;
}) => {
  if (!object) {
    return null;
  }

  const logo = object.logo || object.logoUrl;

  if (logo) {
    return (
      <Avatar
        src={readFile(logo)}
        alt={object.name}
        style={{
          ...logoStyle,
          marginRight: '5px',
        }}
      />
    );
  }

  const words = object.name?.split(' ') || [];
  const initials = words
    .slice(0, 3)
    .map(word => word[0])
    .join('')
    .toUpperCase();

  return (
    <Box sx={style}>
      <Box
        sx={theme => ({
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 'bold',
          ...(logoStyle || {}),
        })}
      >
        {initials}
      </Box>
    </Box>
  );
};

export default LogoOrFromName;
